package com.presentocracy.shared.contract

private val wishlistNavigationId = Regex("[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}")

/** Identifies a destination, not an access capability. Authorization is always server-side. */
fun parseWishlistNavigationId(value: String?): String? = value?.takeIf { wishlistNavigationId.matches(it) }

fun wishlistNavigationQuery(id: String): String {
    require(parseWishlistNavigationId(id) != null) { "Invalid wishlist identifier" }
    return "?wishlist_id=$id"
}
